import { axios } from "@/utils"

export default {
    getConfiguration(appName, params) {
        return axios.get(`api/v1/app-config/${appName}/`, { params: params })
    },
}
